//150
import { useGLTF } from '@react-three/drei';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { PaintColorMaterial } from '../../utils/materials';

export function Addy_3drawer_bedside_dresser(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Addy 3-Drawer Bedside Dresser.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-addy_3_drawer_bedside_dresser-paint_color',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Screw.geometry}
        material={materials.Screw}
      />
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <mesh
        castShadow
        geometry={nodes.interior.geometry}
        material={PaintColorMaterial}
      />
      <Shadow model={'modelName'} />
    </group>
  );
}

function Shadow() {
  const { nodes, materials } = useGLTF(
    'models/shadow/Addy 3-Drawer Bedside Dresser.glb',
  );

  useEffect(() => {
    if (materials.shadow_catcher) {
      materials.shadow_catcher.roughness = 1; // Set roughness to 1
      materials.shadow_catcher.opacity = 0.5; // Set opacity to 0.5
      materials.shadow_catcher.transparent = true; // Ensure transparency is enabled
    }
  }, [materials, nodes]);

  return (
    <group name={'Mainecottage'} dispose={null}>
      <mesh
        castShadow
        geometry={nodes.shadow_catcher.geometry}
        material={materials.shadow_catcher}
      />
    </group>
  );
}
